const store = new Map<string, any>();

export function set<T>(key: string, value: T) {
  store.set(key, { value });
}

export function remove(key: string) {
  store.delete(key);
}

export function get<T>(key: string): T | undefined {
  const cached = store.get(key);

  if (!cached) return;

  return cached.value;
}

export function flush(): void {
  store.clear();
}

export function getAllKeys(): string[] {
  return Array.from(store.keys());
}
